import type { ReactNode } from 'react';

export function PageHeader({
  backLink,
  title,
  titleAction,
  description,
  actions,
}: {
  backLink?: ReactNode;
  title: ReactNode;
  titleAction?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div className="page-heading">
        {backLink ? <div className="back-link">{backLink}</div> : null}
        <div className="page-title-row">
          <div className="page-title-copy">
            <h1>{title}</h1>
            {description ? <p>{description}</p> : null}
          </div>
          {titleAction ? <div className="page-title-action">{titleAction}</div> : null}
        </div>
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </header>
  );
}
